import { render } from "./SingleAnnouncement.vue?vue&type=template&id=2de2d4e8"
import script from "./SingleAnnouncement.vue?vue&type=script&lang=js"
export * from "./SingleAnnouncement.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__